module.exports = __webpack_public_path__ + "assets/img/spoon.99830572.svg";